/* CLEAR OIL – teaser
   Astro 版（clear-oil/public/js/main.js）と同一。直すときは両方そろえること。
   Dawn は <html class="js"> を静的に付けるため、CSS 側のゲートは 'co-js' を使う。 */
(function () {
  'use strict';

  /* ---------------- ドロワーメニュー ---------------- */
  function initDrawer() {
    var drawer = document.getElementById('drawer');
    var opener = document.querySelector('[data-drawer-open]');
    if (!drawer || !opener) return;

    var scrollY = 0;

    function open() {
      scrollY = window.scrollY;
      // body を fixed にするとスクロールバーが消えて中身が右にずれるため、
      // 消える幅ぶんだけ padding で埋める（PC でメニューを開いたときのガタつき対策）
      var barWidth = window.innerWidth - document.documentElement.clientWidth;
      drawer.hidden = false;
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.width = '100%';
      if (barWidth > 0) document.body.style.paddingRight = barWidth + 'px';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      // 0904 修正指示「✕ を押すとメニューが閉じた後にスクロールのような動作が発生する」。
      // 原因は base.css の html { scroll-behavior: smooth }。開いている間 body を
      // fixed にしてスクロール位置を退避しているので、閉じるときに元の位置へ戻すが、
      // その scrollTo が smooth 指定を拾ってアニメーションしていた
      // （トップでは scrollY が 0 なので動かず、トップ以外でだけ症状が出ていた）。
      // 復帰の一瞬だけ scroll-behavior を切って、位置を即座に戻す。
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollY);
      root.style.scrollBehavior = prevBehavior;
      opener.focus();
    }

    opener.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
    // 0904 修正指示：メニュー以外の箇所を押したときも閉じる。
    // PC のドロワーは画面上部 278px のパネルなので、その外側（＝ページ本文）を
    // 押したら閉じる。SP は全画面なので、ここに入るのは max-width の外側だけ。
    // ハンバーガー自身のクリックは open() が処理するので除外する
    // （除外しないと、開いた直後にこのハンドラまで伝播して即座に閉じてしまう）。
    document.addEventListener('click', function (e) {
      if (drawer.hidden) return;
      if (drawer.contains(e.target) || opener.contains(e.target)) return;
      close();
    });
  }

  /* ---------------- アコーディオン ---------------- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));

        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.transition = 'height .25s ease';
            panel.style.height = '0px';
          });
          panel.addEventListener('transitionend', function done() {
            panel.hidden = true;
            panel.style.transition = '';
            panel.style.height = '';
            panel.removeEventListener('transitionend', done);
          });
        } else {
          panel.hidden = false;
          var h = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(function () {
            panel.style.transition = 'height .25s ease';
            panel.style.height = h + 'px';
          });
          panel.addEventListener('transitionend', function done() {
            panel.style.transition = '';
            panel.style.height = '';
            panel.removeEventListener('transitionend', done);
          });
        }
      });
    });
  }

  /* ---------------- POINT カルーセル ---------------- */
  function initCarousel() {
    var track = document.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-carousel-dot]'));
    if (!slides.length) return;

    function current() {
      var min = Infinity;
      var idx = 0;
      var base = track.getBoundingClientRect().left;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().left - base - 36.9);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }

    function sync() {
      var i = current();
      dots.forEach(function (d, j) {
        d.setAttribute('aria-selected', String(j === i));
      });
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });

    sync();
  }

  /* ---------------- お問い合わせフォーム（入力 ⇄ 確認 ⇄ 完了） ---------------- */
  function initContact() {
    // Astro では <form> 自体に、Shopify では {% form %} の内側の要素に付くため、
    // 見つけた要素から最も近い <form> を辿る
    var scope = document.querySelector('[data-contact-form]');
    if (!scope) return;
    var form = scope.closest('form') || scope;

    var errorBox = form.querySelector('[data-contact-error]');
    var btnConfirm = form.querySelector('[data-contact-step="confirm"]');
    var btnSubmit = form.querySelector('[data-contact-step="submit"]');
    var btnBack = form.querySelector('[data-contact-step="back"]');
    var controls = Array.prototype.slice.call(form.querySelectorAll('.cform__input'));

    function setMode(confirming) {
      controls.forEach(function (el) {
        var view = form.querySelector('[data-confirm-for="' + el.name + '"]');
        el.hidden = confirming;
        if (view) {
          view.hidden = !confirming;
          if (confirming) view.textContent = el.value.trim() || '（未入力）';
        }
      });
      btnConfirm.hidden = confirming;
      btnSubmit.hidden = !confirming;
      btnBack.hidden = !confirming;
      form.dataset.mode = confirming ? 'confirm' : 'input';
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validate() {
      var errors = [];
      controls.forEach(function (el) {
        if (el.required && !el.value.trim()) {
          var label = form.querySelector('label[for="' + CSS.escape(el.id) + '"]');
          errors.push((label ? label.textContent.replace('*', '').trim() : '必須項目') + 'を入力してください。');
        } else if (el.type === 'email' && el.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value)) {
          errors.push('メールアドレスの形式をご確認ください。');
        }
      });
      if (errors.length) {
        errorBox.textContent = errors.join(' ');
        errorBox.hidden = false;
        return false;
      }
      errorBox.hidden = true;
      return true;
    }

    btnConfirm.addEventListener('click', function () {
      if (validate()) setMode(true);
    });
    btnBack.addEventListener('click', function () { setMode(false); });

    form.addEventListener('submit', function (e) {
      // Shopify(Dawn) 上では {% form 'contact' %} が action を持つため、
      // ここでの preventDefault は静的プレビュー時のみ有効。
      if (form.getAttribute('action')) return;

      e.preventDefault();
      var viewForm = document.querySelector('[data-contact-view="form"]');
      var viewDone = document.querySelector('[data-contact-view="done"]');
      if (viewForm) viewForm.hidden = true;
      if (viewDone) viewDone.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------------- リロード時は必ずページ先頭から ---------------- */
  function initScrollTop() {
    if (location.hash) return; // アンカー付きで開かれたときはそのまま
    // 遅延読み込み画像でレイアウトが動いた後もずれないよう、数回押さえる。
    // scroll-behavior: smooth が効くとスルスル戻ってしまうので、その間だけ auto にする
    // 読み込み直後にユーザーが自分でスクロールしていたら、それを尊重して戻さない
    var touched = false;
    var mark = function () { touched = true; };
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) {
      window.addEventListener(t, mark, { passive: true, once: true });
    });

    var reset = function () {
      if (touched) return;
      var root = document.documentElement;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, 0);
      root.style.scrollBehavior = prev;
    };
    reset();
    window.addEventListener('load', reset);
    setTimeout(reset, 60);
    setTimeout(function () {
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) {
        window.removeEventListener(t, mark);
      });
    }, 1000);
  }

  /* ---------------- メインビジュアルの演出 ---------------- */
  function initHero() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var img = hero.querySelector('.hero__img');

    function start() {
      // 1 フレーム待ってから開始状態→終了状態へ遷移させる（transition を確実に走らせる）
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      });
    }

    if (!img || img.complete) start();
    else {
      img.addEventListener('load', start, { once: true });
      img.addEventListener('error', start, { once: true });
      setTimeout(start, 2500); // 読み込みが遅い場合の保険
    }
  }

  /* ---------------- メインビジュアルのパララックス ----------------
     枠からはみ出している高さぶんだけ、スクロールに合わせて写真を下に流す。
     ページが上に抜けても写真がその場に残っていくように見える。
     はみ出しが 0 の SP では可動域も 0 になり、自動的に何も起きない。 */
  function initHeroParallax() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var media = hero.querySelector('[data-hero-media]');
    if (!media) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var max = 0;
    var heroH = 1;

    function measure() {
      media.style.transform = '';
      heroH = hero.offsetHeight || 1;
      max = Math.max(0, media.offsetHeight - heroH);
      update();
    }

    function update() {
      if (max <= 0) { media.style.transform = ''; return; }
      var p = window.pageYOffset / heroH;
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      media.style.transform = 'translate3d(0,' + (p * max).toFixed(1) + 'px,0)';
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }

    var rt;
    function onResize() {
      clearTimeout(rt);
      rt = setTimeout(measure, 150);
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', measure);
  }

  /* ---------------- スクロールに合わせたフェードイン ---------------- */
  function initReveal() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!targets.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var MARGIN = 0.12; // 画面下端から 12% 手前で出しはじめる

    function show(el) {
      el.classList.add('is-revealed');
      var i = targets.indexOf(el);
      if (i > -1) targets.splice(i, 1);
      if (io) io.unobserve(el);
    }

    function sweep() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      targets.slice().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * (1 - MARGIN) && r.bottom > 0) show(el);
      });
      if (!targets.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sweep(); });
    }

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) show(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
      targets.forEach(function (el) { io.observe(el); });
    }

    // IntersectionObserver はアンカー遷移や遅延読込によるレイアウト変動の直後に
    // 取りこぼすことがあるため、スクロール監視を併用する（全部出たら自動で外れる）
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', sweep);
    // BFCache から復帰したときは load も DOMContentLoaded も発火しないため、
    // ここで拾わないと「戻る」で来たときにフェード待ちのまま残る要素が出る
    window.addEventListener('pageshow', sweep);

    // 初回はレイアウトが確定してから判定する。
    // DOMContentLoaded の時点で測ると、initScrollTop() のスクロール戻しや
    // Web フォントの差し替えが済んでおらず、画面外の要素まで
    // 「もう見えている」と判定して先に出してしまうことがある。
    requestAnimationFrame(function () { requestAnimationFrame(sweep); });
  }

  /* ---------------- 背景ぼかしのパララックス ---------------- */
  function initParallax() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var entries = [];

    // transform をかける前の基準位置（ドキュメント座標）をキャッシュする。
    // getBoundingClientRect は transform 後の値を返すため、毎フレーム参照すると発散する。
    function measure() {
      entries = items.map(function (el) {
        el.style.transform = '';
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        return {
          el: el,
          top: r.top + window.pageYOffset,
          h: el.offsetHeight,
          speed: speed,
          max: 380 * speed, // 振れ幅の上限（±px）
        };
      });
      update();
    }

    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var sy = window.pageYOffset;
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        var center = e.top + e.h / 2 - sy - vh / 2;
        if (center < -vh - e.h || center > vh + e.h) continue; // 画面から大きく外れていれば更新しない
        var t = -center * e.speed;
        // ビューポートが高い環境（PC など）で動きすぎないよう振れ幅を制限する
        if (t > e.max) t = e.max;
        else if (t < -e.max) t = -e.max;
        e.el.style.transform = 'translate3d(0,' + t.toFixed(1) + 'px,0)';
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }

    var rt;
    function onResize() {
      clearTimeout(rt);
      rt = setTimeout(measure, 150);
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', measure);
  }

  function init() {
    initScrollTop();
    initHero();
    initHeroParallax();
    initReveal();
    initParallax();
    initDrawer();
    initAccordion();
    initCarousel();
    initContact();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
